export default "__VITE_ASSET__itmFKefp__"